import React from 'react'
import cx from 'classnames'
import styleProvider, {
  SizeImage,
} from '@quotatisgroup/uikit-public.style-provider'

import './icon.scss'

export type IconProps = {
  className?: string
  classes?: string
  name: string
  size?: SizeImage
  isBlock?: boolean
  md?: 'hide' | undefined
  sm?: 'hide' | undefined
  onClick?: () => void
  id?: string
}

const IconComponent = ({
  classes,
  className,
  name,
  size = 'sm',
  isBlock,
  md,
  sm,
  onClick,
  id,
}: IconProps) => {
  return (
    <img
      id={id}
      onClick={onClick}
      src={`https://res.cloudinary.com/quotatis/image/upload/FrontApp/vitrine/icon/${name}.svg`}
      alt="icon"
      className={cx(
        classes,
        `icon`,
        `icon-${size}`,
        {
          block: isBlock,
          [`md-${md}`]: md,
          [`sm-${sm}`]: sm,
        },
        className,
      )}
    />
  )
}

export const Icon = styleProvider(IconComponent)
